import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-ecommerce-menu',
    templateUrl: './ecommerce-menu.component.html',
    styleUrls: ['./ecommerce-menu.component.css'],
})
export class EcommerceMenuComponent {
    /**
     * The name of the ecommerce webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
